module.exports = __webpack_public_path__ + "static/media/imgAssess.69c1bea7.png";